export class TenantconfigVO {
    public id: number;
     public  key: string;
     public  value: string;;
    
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/model/TenantconfigVO.ts